import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ProductConfiguration from '../components/ProductConfiguration';
import {setProductConfig} from '../../product-picker/actions/product-picker';
import {setBundleProductConfig} from '../../bundle-picker/actions/bundle-picker';
import ContainerProps from './ProductWrapperComponent';

class ProductConfigurationWrapper extends Component<ContainerProps> {
    render() {
        return (<ProductConfiguration
                    key={this.props.configKey}
                    product={this.props.product}
                    configKey={this.props.configKey}
                    onProductConfigChange={this.onProductConfigChange}
                    productQuantity={this.props.productQuantity}
                    bundleQuantity={this.props.bundleQuantity}
                    bundle={this.props.bundle}
        />)
    }

    onProductConfigChange = (configuration) => {
        if (this.props.bundle) {
            configuration.bundleId = this.props.bundle.id;
            this.props.setBundleProductConfig(configuration, this.props.reducerKey);
        } else {
            this.props.setProductConfig(configuration, this.props.reducerKey);
        }
    }
}

const mapStateToProps = state => {
    return {
        products: state.products.products,
        productsQuantities: state.productPicker.productsQuantities,
    }
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({setProductConfig, setBundleProductConfig}, dispatch);
};

ProductConfigurationWrapper.propTypes = {
    product: PropTypes.object.isRequired,
    configKey: PropTypes.number,
    productQuantity: PropTypes.number,
    bundleQuantity: PropTypes.number,
    bundle: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductConfigurationWrapper)
